import { shuffleAnswers, getOriginalIndex } from './shuffleAnswers.ts';

/**
 * Test simple pour vérifier que shuffleAnswers fonctionne correctement
 */
export const testShuffleAnswers = () => {
  console.log('🧪 Test des fonctions shuffleAnswers');
  
  const originalOptions = [
    "Réponse A",
    "Réponse B", 
    "Réponse C",
    "Réponse D"
  ];
  
  console.log('📋 Options originales:', originalOptions);
  
  // Test 1: Vérifier que toutes les réponses sont présentes
  const shuffled = shuffleAnswers(originalOptions);
  console.log('🔀 Options mélangées:', shuffled);
  
  const shuffledTexts = shuffled.map(s => s.text);
  const allPresent = originalOptions.every(option => shuffledTexts.includes(option));
  console.log('✅ Toutes les options sont présentes:', allPresent);
  
  // Test 2: Vérifier les indices originaux
  shuffled.forEach((shuffledAnswer, newIndex) => {
    const originalIndex = shuffledAnswer.originalIndex;
    const shouldBe = originalOptions[originalIndex];
    console.log(`🔍 Position ${newIndex}: "${shuffledAnswer.text}" (index original: ${originalIndex}, devrait être: "${shouldBe}")`);
    console.log(`   ✅ Correct:`, shuffledAnswer.text === shouldBe);
  });
  
  // Test 3: Vérifier getOriginalIndex
  shuffled.forEach(shuffledAnswer => {
    const foundIndex = getOriginalIndex(shuffled, shuffledAnswer.text);
    console.log(`🔍 getOriginalIndex("${shuffledAnswer.text}") = ${foundIndex}, attendu: ${shuffledAnswer.originalIndex}`);
    console.log(`   ✅ Correct:`, foundIndex === shuffledAnswer.originalIndex);
  });
  
  console.log('🏁 Test terminé');
};

// Exporter pour pouvoir l'appeler depuis la console
(window as any).testShuffleAnswers = testShuffleAnswers;
